import React from "react";

export default React.createContext({
  divider: true,
  showDivider: () => {}
});